<div class="row">
    <!-- <div class="col-md-auto">
  <app-camp-icon [iconName]="item.campIconName"></app-camp-icon>
</div> -->
    <div class="col">
        <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1 main-blue bolded" hznTestId="roster-row-camper">{{ item.camperName }}</h6>
            @if (item.isRegularSession) {
                <small class="text-muted">
                    <span hznTestId="roster-row-date">{{ item.date | bcDate }}</span> ({{
                        "Roster.regular" | translate
                    }})</small
                >
            }
            @if (!item.isRegularSession) {
                <small class="text-muted"
                    ><span hznTestId="roster-row-date">{{ item.date | bcDate }}</span> ({{
                        "Roster.campCare" | translate
                    }})</small
                >
            }
        </div>
        @if (item.isRegularSession) {
            <p class="mb-1 bolded">{{ item.sessionName }}</p>
        }
        @if (item.visit) {
            <small class="text-muted d-block">
                @if (item.visit.checkinInfo) {
                    <span
                        ><span>{{ "Roster.checkinTime" | translate }}</span>
                        <span class="bolded">{{
                            item.visit.checkinInfo
                        }}</span></span
                    >
                }
                @if (item.visit.estimatedCheckout) {
                    <span
                        ><span>{{
                            "Roster.estimatedCheckoutTime" | translate
                        }}</span>
                        <span class="bolded">{{
                            item.visit.estimatedCheckout
                        }}</span></span
                    >
                }
            </small>
        }
        @if (item.visit) {
            <small class="text-muted d-block">
                @if (item.visit.checkoutInfo) {
                    <span
                        ><span>{{ "Roster.checkoutTime" | translate }}</span>
                        <span class="bolded">{{
                            item.visit.checkoutInfo
                        }}</span>
                        @if (item.checkoutPerson) {
                            <span class="bolded"
                                >({{ item.checkoutPerson }})</span
                            >
                        }
                    </span>
                }
            </small>
        }
    </div>
</div>
